exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-leadgen-v2-Common-Form__form--1PECN{width:50%;min-width:450px;margin:0 auto}@media (max-width: 500px){.src-components-leadgen-v2-Common-Form__form--1PECN{width:100%;min-width:0}}.src-components-leadgen-v2-Common-Form__form--1PECN .src-components-leadgen-v2-Common-Form__errors--3rlGt{color:#ff4d00;font-size:15px;margin-top:20px}\n", ""]);

// Exports
exports.locals = {
	"form": "src-components-leadgen-v2-Common-Form__form--1PECN",
	"errors": "src-components-leadgen-v2-Common-Form__errors--3rlGt"
};